const BASE = process.env.REACT_APP_API_BASE_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

const authHeadersOnly = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

// Profile
export const getProfile = () =>
  fetch(`${BASE}/api/profile`, { headers: authHeaders() }).then(r => r.json());

export const updateBasic = (data) =>
  fetch(`${BASE}/api/profile/basic`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());

export const updateHeadline = (data) =>
  fetch(`${BASE}/api/profile/headline`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());

export const updateSummary = (data) =>
  fetch(`${BASE}/api/profile/summary`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());

export const updateCareer = (data) =>
  fetch(`${BASE}/api/profile/career`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());

export const updatePersonal = (data) =>
  fetch(`${BASE}/api/profile/personal`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());

export const updatePhoto = (file) => {
  const fd = new FormData();
  fd.append('photo', file);
  return fetch(`${BASE}/api/profile/photo`, { method: 'PUT', headers: authHeadersOnly(), body: fd }).then(r => r.json());
};

export const deletePhoto = () =>
  fetch(`${BASE}/api/profile/photo`, { method: 'DELETE', headers: authHeaders() }).then(r => r.json());

export const saveSkills = (skills) =>
  fetch(`${BASE}/api/profile/skills`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify({ skills }) }).then(r => r.json());

// Resume upload → parse → prefill
export const uploadAndPrefill = (file) => {
  const fd = new FormData();
  fd.append('resume', file);
  return fetch(`${BASE}/api/profile/upload-resume`, { method: 'POST', headers: authHeadersOnly(), body: fd })
    .then(r => { if (!r.ok) throw new Error('Parse failed'); return r.json(); });
};

// Theme
export const updateTheme = (theme) =>
  fetch(`${BASE}/api/profile/theme`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ theme })
  }).then(r => r.json());

// Public link
export const generatePublicLink = () =>
  fetch(`${BASE}/api/profile/generate-public-link`, { method: 'POST', headers: authHeaders() }).then(r => r.json());

export const getPublicProfile = (token) =>
  fetch(`${BASE}/api/profile/public/${token}`).then(r => { if (!r.ok) throw new Error('Not found'); return r.json(); });

// IT Skills
export const addItSkill = (data) =>
  fetch(`${BASE}/api/profile/it-skills`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const updateItSkill = (id, data) =>
  fetch(`${BASE}/api/profile/it-skills/${id}`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteItSkill = (id) =>
  fetch(`${BASE}/api/profile/it-skills/${id}`, { method: 'DELETE', headers: authHeaders() });

// Employments
export const addEmployment = (data) =>
  fetch(`${BASE}/api/profile/employments`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const updateEmployment = (id, data) =>
  fetch(`${BASE}/api/profile/employments/${id}`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteEmployment = (id) =>
  fetch(`${BASE}/api/profile/employments/${id}`, { method: 'DELETE', headers: authHeaders() });

// Educations
export const addEducation = (data) =>
  fetch(`${BASE}/api/profile/educations`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const updateEducation = (id, data) =>
  fetch(`${BASE}/api/profile/educations/${id}`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteEducation = (id) =>
  fetch(`${BASE}/api/profile/educations/${id}`, { method: 'DELETE', headers: authHeaders() });

// Projects
export const addProject = (data) =>
  fetch(`${BASE}/api/profile/projects`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const updateProject = (id, data) =>
  fetch(`${BASE}/api/profile/projects/${id}`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteProject = (id) =>
  fetch(`${BASE}/api/profile/projects/${id}`, { method: 'DELETE', headers: authHeaders() });

// Certifications
export const addCertification = (data) =>
  fetch(`${BASE}/api/profile/certifications`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteCertification = (id) =>
  fetch(`${BASE}/api/profile/certifications/${id}`, { method: 'DELETE', headers: authHeaders() });

// Online Profiles
export const addOnlineProfile = (data) =>
  fetch(`${BASE}/api/profile/online-profiles`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteOnlineProfile = (id) =>
  fetch(`${BASE}/api/profile/online-profiles/${id}`, { method: 'DELETE', headers: authHeaders() });

// Work Samples
export const addWorkSample = (data) =>
  fetch(`${BASE}/api/profile/work-samples`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteWorkSample = (id) =>
  fetch(`${BASE}/api/profile/work-samples/${id}`, { method: 'DELETE', headers: authHeaders() });

// Publications
export const addPublication = (data) =>
  fetch(`${BASE}/api/profile/publications`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deletePublication = (id) =>
  fetch(`${BASE}/api/profile/publications/${id}`, { method: 'DELETE', headers: authHeaders() });

// Presentations
export const addPresentation = (data) =>
  fetch(`${BASE}/api/profile/presentations`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deletePresentation = (id) =>
  fetch(`${BASE}/api/profile/presentations/${id}`, { method: 'DELETE', headers: authHeaders() });

// Patents
export const addPatent = (data) =>
  fetch(`${BASE}/api/profile/patents`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deletePatent = (id) =>
  fetch(`${BASE}/api/profile/patents/${id}`, { method: 'DELETE', headers: authHeaders() });

// Languages
export const addLanguage = (data) =>
  fetch(`${BASE}/api/profile/languages`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const updateLanguage = (id, data) =>
  fetch(`${BASE}/api/profile/languages/${id}`, { method: 'PUT', headers: authHeaders(), body: JSON.stringify(data) }).then(r => r.json());
export const deleteLanguage = (id) =>
  fetch(`${BASE}/api/profile/languages/${id}`, { method: 'DELETE', headers: authHeaders() });
